const SESSION_FLAG = 'landcorp_meta_ads_attribution';

function normalizeSource(raw: string): string {
  return raw.trim().toLowerCase();
}

/** Query params that indicate traffic from Meta ads (UTM + click id). */
export function isMetaAdsTrafficParams(params: URLSearchParams): boolean {
  if (params.get('fbclid')?.trim()) return true;

  const source = normalizeSource(params.get('utm_source') ?? '');
  const medium = normalizeSource(params.get('utm_medium') ?? '');

  const metaSources = ['facebook', 'fb', 'instagram', 'ig', 'meta', 'messenger', 'msgr'];
  if (metaSources.some((s) => source === s || source.startsWith(`${s}_`))) {
    return true;
  }

  const paidLike =
    medium === 'paid' ||
    medium === 'cpc' ||
    medium === 'cpm' ||
    medium === 'social' ||
    medium === 'paid_social' ||
    medium === 'ppc';

  if (paidLike && metaSources.some((s) => source === s || source.includes(s))) {
    return true;
  }

  return false;
}

export function persistMetaAdsSessionIfPresent(search: string): void {
  if (typeof window === 'undefined') return;
  const params = new URLSearchParams(search);
  if (!isMetaAdsTrafficParams(params)) return;
  try {
    sessionStorage.setItem(SESSION_FLAG, '1');
  } catch {
    /* private mode / quota */
  }
}

/** True if the current URL or this browser tab's session was attributed to Meta ads. */
export function isMetaAdsSession(): boolean {
  if (typeof window === 'undefined') return false;
  if (isMetaAdsTrafficParams(new URLSearchParams(window.location.search))) return true;
  try {
    return sessionStorage.getItem(SESSION_FLAG) === '1';
  } catch {
    return false;
  }
}
